module.exports = __webpack_public_path__ + "static/media/logo_govo.legal.d43138cd.jpg";